export class AdresseIP {
    
  constructor() {}

  getAdresseIP() {
    return "/diplome";
    //return "http://10.67.247.178:8094"; 
    
  }
}
